import React from "react";
import { Image, Upload, message, Button, Flex, Space, Modal, Checkbox } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {CopyToClipboard} from 'react-copy-to-clipboard';

export default ({ onChange, selected = false }) => { 
    const [files, setFiles] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [tokens, setTokens] = React.useState(['']);
    const [selectedFiles, setSelectedFiles] = React.useState([]);

    React.useEffect(() => {
        getFiles().then((res) => {
            setFiles(res);
        });
    }, []);
    const getFiles = async (token = '', page = 0) => {
        const response = await fetch(`/api/album/list?token=${token}&pageSize=14`);
        const res = await response.json();
        
        if(res?.success) {
            // console.log('=====1',tokens);
            // console.log('=====',res.data.nextContinuationToken);
            
            if(res?.data?.nextContinuationToken){
                // setPrev(next);
                const nextToken = res.data.nextContinuationToken;
                // console.log('=====2',nextToken);

                if(tokens.indexOf(nextToken) === -1) {
                    setTokens([...tokens, nextToken]);
                }
            }else{
                setPage(page - 1);
            }
            // console.log('=====3',tokens);
            // if(res?.data?.continuationToken) setPrev(res.data.continuationToken);
            return res?.data?.objects || [];
        }

        return [];
    };

    const turnPage = async (page) => {
        console.log('turnPage', page);
        setPage(page);
        const token = tokens[page];
        const res = await getFiles(token, page);
        setFiles(res);
    };

    const beforeUpload = async (file) => {
        // console.log('beforeUpload', file);
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
        if (!isJpgOrPng) {
            message.error('请上传JPG/PNG图片!');
        }
        const isLt8M = file.size / 1024 / 1024 < 8;
        if (!isLt8M) {
            message.error('图片必须小于 8MB!');
        }
        // console.log('upload', file);

        return isJpgOrPng && isLt8M;
    };

    const del = async (name) => {
        
        Modal.confirm({
            title: '删除图片',
            content: '确定要删除此图片吗？',
            okText: '删除',
            okType: 'danger',
            cancelText: '取消',
            onOk: async () => {
                const response = await fetch(`/api/album/delete`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        name,
                    })
                });

                const result = await response.json();

                if(result?.success) {
                    message.success('删除成功');
                    setTimeout(() => {
                        getFiles().then((res) => {
                            setFiles(res);
                        });
                    }, 500);
                }else {
                    message.error(result.data);
                }
            },
        });
    };

    const handleChange = () => { 
        getFiles().then((res) => {
            setFiles(res);
        });
    };

    const onFileCheck = (e, file) => {
        console.log(e.target.checked, file);
        const checkd = e.target.checked;

        if(checkd) {
            setSelectedFiles([...selectedFiles, file]);
        }else{
            setSelectedFiles(selectedFiles.filter(item => item.name !== file.name));
        }

        onChange?.(selectedFiles, files);
    };

    return (
        <div>
            <div className="album-container" style={{ display: 'flex', flexFlow: 'row wrap', gap: '10px', justifyContent: 'space-between' }}>
                <Upload
                    // name="avatar"
                    // listType="picture-card"
                    className="avatar-uploader"
                    // fileList={detailImages}
                    // maxCount={8}
                    action="/api/upload/image"
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                    itemRender={(originNode, file) => null}
                >
                    <Button style={{width: 100, height: 100}} icon={<PlusOutlined />}>上传</Button>
                </Upload>
                {
                    files.map((file) => (
                        <div key={file.name} style={{ border: '1px solid #efefef'}}>
                            <Image
                                src={'https://img.yxdj.tech/'+file.name+'?x-oss-process=image/resize,w_200'}
                                width={100}
                                height={100}
                                preview={{ src: 'https://img.yxdj.tech/'+file.name }}
                            />
                            {selected === false && <Flex justify="space-around" align="center">
                                <a style={{ fontSize: '12px'}} onClick={() => del(file.name)}>删除</a>
                                <span style={{color: '#efefef'}}>|</span>
                                <CopyToClipboard text={file.name} onCopy={() => message.success('复制成功')}>
                                    <a style={{ fontSize: '12px'}}>URL</a>
                                </CopyToClipboard>
                            </Flex>}

                            {
                                selected && ( 
                                    <div style={{textAlign: 'center'}}>
                                        <Checkbox onChange={(e) => onFileCheck(e, file)}>
                                            {/* <span style={{color: '#efefef'}}>|</span> */}
                                            <a style={{ fontSize: '12px'}}>选择</a>
                                        </Checkbox>
                                    </div>
                                )
                            }
                        </div>
                    ))
                }
            </div>
            <Space style={{marginTop: '10px'}}>
                {page >0 && <a onClick={() => turnPage(page - 1)}>上一页</a>}
                <a onClick={() => turnPage(page + 1)}>下一页</a>
            </Space>
        </div>
    );
};